
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BelongsToCompany,
  InvitationContextResponse,
  InvitationFreelancers,
  InvitationType,
  PartnershipHighlights,
} from '../models';
import {
    BelongsToCompanyFromJSON,
    BelongsToCompanyToJSON,
    InvitationContextResponseFromJSON,
    InvitationContextResponseToJSON,
    InvitationFreelancersFromJSON,
    InvitationFreelancersToJSON,
    InvitationTypeFromJSON,
    InvitationTypeToJSON,
    PartnershipHighlightsFromJSON,
    PartnershipHighlightsToJSON,
} from '../models';

export interface BelongsToCompanyRequest {
    invitationCode: string;
    invitationType: InvitationType;
}

export interface GetFreelancersForInvitationRequest {
    invitationCode: string;
    invitationType: InvitationType;
}

export interface GetInvitationContextRequest {
    invitationCode: string;
    invitationType: InvitationType;
}

export interface GetPartnershipHighlightsRequest {
    invitationCode: string;
    invitationType: InvitationType;
}

/**
 * 
 */
export class ClientSignupInvitationContextApi extends runtime.BaseAPI {

    /**
     * Answer yes if the current logged user belong to the invitation company
          */
    async belongsToCompanyRaw(requestParameters: BelongsToCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BelongsToCompany>> {
        if (requestParameters['invitationCode'] == null) {
            throw new runtime.RequiredError(
                'invitationCode',
                'Required parameter "invitationCode" was null or undefined when calling belongsToCompany().'
            );
        }

        if (requestParameters['invitationType'] == null) {
            throw new runtime.RequiredError(
                'invitationType',
                'Required parameter "invitationType" was null or undefined when calling belongsToCompany().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['invitationCode'] != null) {
            queryParameters['invitationCode'] = requestParameters['invitationCode'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitationType'] = requestParameters['invitationType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BelongsToCompany>({
            path: `/signup-client/api/belongs-to-company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BelongsToCompanyFromJSON(response._data); }
        return response;
    }

    /**
     * Answer yes if the current logged user belong to the invitation company
          */
    async belongsToCompany(requestParameters: BelongsToCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BelongsToCompany> {
        const response = await this.belongsToCompanyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get a sample of freelancer linked to the company
          */
    async getFreelancersForInvitationRaw(requestParameters: GetFreelancersForInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<InvitationFreelancers>> {
        if (requestParameters['invitationCode'] == null) {
            throw new runtime.RequiredError(
                'invitationCode',
                'Required parameter "invitationCode" was null or undefined when calling getFreelancersForInvitation().'
            );
        }

        if (requestParameters['invitationType'] == null) {
            throw new runtime.RequiredError(
                'invitationType',
                'Required parameter "invitationType" was null or undefined when calling getFreelancersForInvitation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['invitationCode'] != null) {
            queryParameters['invitationCode'] = requestParameters['invitationCode'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitationType'] = requestParameters['invitationType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<InvitationFreelancers>({
            path: `/signup-client/api/invitation/freelancers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=InvitationFreelancersFromJSON(response._data); }
        return response;
    }

    /**
     * Get a sample of freelancer linked to the company
          */
    async getFreelancersForInvitation(requestParameters: GetFreelancersForInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<InvitationFreelancers> {
        const response = await this.getFreelancersForInvitationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get context to render the invitation page
          */
    async getInvitationContextRaw(requestParameters: GetInvitationContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<InvitationContextResponse>> {
        if (requestParameters['invitationCode'] == null) {
            throw new runtime.RequiredError(
                'invitationCode',
                'Required parameter "invitationCode" was null or undefined when calling getInvitationContext().'
            );
        }

        if (requestParameters['invitationType'] == null) {
            throw new runtime.RequiredError(
                'invitationType',
                'Required parameter "invitationType" was null or undefined when calling getInvitationContext().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['invitationCode'] != null) {
            queryParameters['invitationCode'] = requestParameters['invitationCode'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitationType'] = requestParameters['invitationType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<InvitationContextResponse>({
            path: `/signup-client/api/invitation-context`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=InvitationContextResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get context to render the invitation page
          */
    async getInvitationContext(requestParameters: GetInvitationContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<InvitationContextResponse> {
        const response = await this.getInvitationContextRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get partnership highlights data for the invitation page (team members, projects, ratings, freelancers pool)
          */
    async getPartnershipHighlightsRaw(requestParameters: GetPartnershipHighlightsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PartnershipHighlights>> {
        if (requestParameters['invitationCode'] == null) {
            throw new runtime.RequiredError(
                'invitationCode',
                'Required parameter "invitationCode" was null or undefined when calling getPartnershipHighlights().'
            );
        }

        if (requestParameters['invitationType'] == null) {
            throw new runtime.RequiredError(
                'invitationType',
                'Required parameter "invitationType" was null or undefined when calling getPartnershipHighlights().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['invitationCode'] != null) {
            queryParameters['invitationCode'] = requestParameters['invitationCode'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitationType'] = requestParameters['invitationType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PartnershipHighlights>({
            path: `/signup-client/api/invitation/partnerships`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PartnershipHighlightsFromJSON(response._data); }
        return response;
    }

    /**
     * Get partnership highlights data for the invitation page (team members, projects, ratings, freelancers pool)
          */
    async getPartnershipHighlights(requestParameters: GetPartnershipHighlightsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PartnershipHighlights> {
        const response = await this.getPartnershipHighlightsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
